import { FC } from 'react';
import { DialogContentText, Box } from '@mui/material';

interface TermsContentProps {
  showAICopy: boolean;
  acceptCopy?: string;
}

export const TermsContent: FC<TermsContentProps> = ({
  showAICopy,
  acceptCopy,
}) => (
  <>
    <DialogContentText sx={{ fontWeight: 'bold', mt: 1 }}>
      Media Center Consent
    </DialogContentText>

    <DialogContentText sx={{ mb: 3 }}>
      Subscribers and the MLS may be sued if proper consent for use of Images
      and Documents is not obtained (including photographs, documents, drawings,
      graphics, renderings, blueprints, audio files, videos, etc.) You confirm
      that you either own the copyright(s) or have obtained the necessary
      written consent for each Image and Document uploaded, in compliance with
      the Subscription Agreement.
    </DialogContentText>

    {showAICopy && (
      <Box>
        <DialogContentText sx={{ fontWeight: 'bold' }}>
          AI Generated Image Description
        </DialogContentText>

        <DialogContentText>
          This artificial intelligence (AI) tool is intended to aid, but not
          replace, human review to create property descriptions for marketing
          purposes. Due to the rapidly advancing and probabilistic nature of AI,
          this tool&apos;s output may be incomplete, inaccurate, unlawful, or
          otherwise unsuitable for use.
        </DialogContentText>

        <DialogContentText>
          By utilizing this tool, you acknowledge and agree:
        </DialogContentText>

        <DialogContentText sx={{ display: 'list-item', ml: 3 }}>
          You will conduct a human review of the output prior to its use.
        </DialogContentText>

        <DialogContentText sx={{ display: 'list-item', ml: 3 }}>
          You bear sole responsibility for the accuracy and suitability of the
          output for your use.
        </DialogContentText>

        <DialogContentText sx={{ display: 'list-item', ml: 3 }}>
          You will not allow this tool or its output to be used in any way that
          is unlawful, infringing, defamatory, misleading, or infringes on
          another&apos;s privacy rights or confidentiality.
        </DialogContentText>
      </Box>
    )}

    {acceptCopy && (
      <DialogContentText sx={{ fontWeight: 'bold', mt: 3 }}>
        {acceptCopy}
      </DialogContentText>
    )}
  </>
);
